<div class="min-h-screen flex flex-col bg-surface-50">
  @if (isAllowedToAccess()) {
    <app-navbar (doUpdate)="doAppUpdate()" [hasNewVersion]="hasNewVersion()" />
    <div class="flex flex-col flex-auto items-center">
      <div class="flex-auto flex flex-col w-full items-center bottom-safe-area-padding">
        <router-outlet></router-outlet>
      </div>
      <div class="hidden lg:flex justify-center w-full">
        <div class="flex justify-center w-full px-8 pb-2 gap-8">
          <div class="text-gray-500 text-xs text-right">
            <div i18n>
              tacs®Recording by
              <a class="text-gray-500 no-underline" href="https://rodix.ch">Rodix AG</a>
            </div>
            <div i18n>
              Developed by
              <a class="text-gray-500 no-underline" href="https://nxt.engineering">nxt Engineering GmbH</a>
            </div>
          </div>
          <div class="flex h-full items-center">
            <img
              alt="powered by Swiss made Software"
              height="36"
              i18n-alt
              ngSrc="assets/swissmade.svg"
              priority
              width="180" />
          </div>
        </div>
      </div>
    </div>
  } @else {
    <div class="flex flex-col flex-auto items-center justify-center" style="height: 100vh">
      <h1 i18n>Du hast keinen Zugriff auf tacs®Recording</h1>
    </div>
  }
</div>
<p-toast [breakpoints]="{ '920px': { width: 'calc(100% - 2rem)', right: '1rem', left: '1rem' } }" />
<p-toast [breakpoints]="{ '920px': { width: 'calc(100% - 2rem)', right: '1rem', left: '1rem' } }" key="update">
  <ng-template #message let-toast>
    <div class="flex flex-row gap-2">
      <fa-icon [icon]="toast.icon" class="text-3xl" />
      <div class="flex-1 flex flex-col">
        <div class="text-xl font-bold mb-2">{{ toast.summary }}</div>
        <div class="mb-2">{{ toast.detail }}</div>
        <div class="flex gap-2">
          <button (click)="toast.data.accept()" class="p-button-success" pButton type="button">
            {{ toast.data.acceptLabel }}
          </button>
        </div>
      </div>
    </div>
  </ng-template>
</p-toast>
<p-confirm-dialog>
  <ng-template #rejecticon>
    <fa-icon icon="xmark" />
  </ng-template>
  <ng-template #accepticon>
    <fa-icon icon="check" />
  </ng-template>
</p-confirm-dialog>
